import { RECRUITERCLIENTSHORTLIST } from "../../ENVIRONMENT";

// api for recruiter shortlist jobs
async function recshortlistJobs(token, data, status) {
  return await fetch(RECRUITERCLIENTSHORTLIST + `?shortlist=${status}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
    body: JSON.stringify(data),
  });
}

export { recshortlistJobs };
